import { useOrganization } from "@/contexts/OrganizationContext";
import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";

/**
 * Route guard that only allows admins and super admins.
 * Managers and learners are redirected to the org dashboard.
 */
export function AdminRoute({ children }: { children: React.ReactNode }) {
  const { isAdmin, loading } = useOrganization();
  const { orgSlug } = useParams<{ orgSlug: string }>();

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  if (!isAdmin) {
    return <Navigate to={`/${orgSlug}`} replace />;
  }

  return <>{children}</>;
}
